import { type ComponentProps } from 'react';
import { Platform } from 'react-native';
import { Searchbar } from 'react-native-paper';

import { useAppTheme } from '@/theme';

type Props = ComponentProps<typeof Searchbar>;

export const AppSearchbar = (props: Props) => {
  const theme = useAppTheme();
  const defaults =
    Platform.OS === 'ios'
      ? { selectionColor: theme.colors.textNdPrimary }
      : {
          selectionColor: theme.colors.bgInfoWeakest,
          cursorColor: theme.colors.textNdPrimary,
          selectionHandleColor: theme.colors.textNdMuted,
        };
  return <Searchbar {...defaults} {...props} />;
};
